import { createContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { api } from "../services/api";

export const DadosUsuarioContext = createContext({});

export function DadosUsuarioProvider({ children }) {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState({});
  const token = localStorage.getItem("@TOKEN");
  const [techss, setTechs] = useState([]);
  const [modalEstaAberto, setModalEstaAberto] = useState(false);

  function abrirModal() {
    setModalEstaAberto(true);
  }

  function fecharModal() {
    setModalEstaAberto(false);
  }

  function pegarDadosCadastro(dados) {
    console.log(dados);
    api
      .post("users", dados)
      .then((response) => {
        toast.success(" Usuario criado com sucesso");
        console.log("Sucesso => ", response);
        return navigate("/");
      })
      .catch((error) => {
        toast.error("Algo deu errado");
        console.log("Erro => ", error);
      });
  }

  function pegarDadosLogin(dados) {
    console.log(dados);
    api
      .post("sessions", dados)
      .then((response) => {
        console.log("Sucesso => ", response);
        localStorage.setItem("@TOKEN", response.data.token);
        toast.success(" Login realizado com sucesso");

        setTimeout(navigate("/dashboard"), 10000);
        setUsuario(response.data.user);
        console.log("SucessoLogin =>", response);
      })
      .catch((erro) => {
        toast.error("Senha ou Email incorreto");

        console.log("Erro => ", erro);
      });
  }

  const buscarUsuario = () => {
    api
      .get("profile", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("@TOKEN")}`,
        },
      })
      .then((res) => {
        setUsuario(res.data);
        console.log(res);
        setTechs(res.data.techs);
      })
      .catch((err) => console.log(err));
  };

  function pegarDadosFormDeTecnologia(dados) {
    api
      .post("users/techs", dados, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        buscarUsuario();
        console.log("Sucesso => ", response);
        toast.success("Tecnologia cadastrada");
      })
      .catch(() => toast.error("Tecnologia ja cadastrada ou campus vagos"));
  }

  const deletartech = (techid) => {
    api
      .delete(`users/techs/${techid}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        buscarUsuario();
        toast("Tecnologia deletada 🗑️", {
          icon: "✅",
        });
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (token) {
      api
        .get("profile", {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          // setTechs(response.data.user.techs);

          toast(" Seja bem vindo", {
            icon: "👏",
          });
          navigate("/dashboard");
          setUsuario(response.data);
          console.log("SucessoUseEffect =>", response);
        })
        .catch((error) => console.log("ErroUseEffect =>", error));
    } else {
      localStorage.removeItem("@TOKEN");
    }
  }, []);

  console.log("Techs=>", techss);
  return (
    <DadosUsuarioContext.Provider
      value={{
        pegarDadosCadastro,
        pegarDadosLogin,
        usuario,
        setUsuario,
        pegarDadosFormDeTecnologia,
        techss,
        deletartech,
        token,
        fecharModal,
        abrirModal,
        modalEstaAberto,
        navigate,
      }}
    >
      {children}
    </DadosUsuarioContext.Provider>
  );
}
